/**
 * Safe avatar initials from first/last name.
 * Empty or missing names (common for business customers) must never throw —
 * callers previously crashed with `first_name[0].toUpperCase()` when a part
 * was null/empty.
 */
export function getPersonInitials(
  firstName?: string | null,
  lastName?: string | null,
  fallback = '?'
): string {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();
  const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  return initials || fallback;
}
